/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Box, Typography } from '@mui/material';
import { FC } from 'react';

export type CounterSlideType = {
	selectedNumber?: number;
	totalSlides?: number;
	isCarouselModalFrame?: boolean;
};

export const CounterSlides: FC<CounterSlideType> = ({
	selectedNumber,
	totalSlides,
	isCarouselModalFrame = false,
}) => (
	<Box
		sx={(theme) => ({
			position: isCarouselModalFrame ? 'relative' : 'absolute',
			bottom: isCarouselModalFrame ? '0' : '18px',
			right: isCarouselModalFrame ? '0' : '19px',
			px: '11px',
			height: '26px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: '#000000',
			opacity: '0.7',
			borderRadius: '13px',
			width: 'fit-content',
			[theme.breakpoints.down(400)]: {
				bottom: isCarouselModalFrame ? '0' : '30px',
			},
			zIndex: 1001,
		})}
	>
		<Typography
			sx={{
				color: '#FFFFFF',
				fontSize: 'var(--font-size-small)',
				fontWeight: '600',
				fontFamily: 'Open Sans',
			}}
		>
			{selectedNumber}
			{'/'}
			{totalSlides}
		</Typography>
	</Box>
);
